// src/components/Sidebar.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';

function Sidebar() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <div className="sidebar">
      <div>
        <img src="/frac7al_tr_bl.png" alt="Frac7al" className="sidebar-logo" />
      </div>
      <h2>FRAC7AL</h2>
      <ul>
        <li><Link to="/workspaces">Workspaces</Link></li>
        <li><Link to="/fractals">Fractales</Link></li>
        <li><Link to="/assessments">Assessments</Link></li>
        <li><button onClick={handleLogout}>Salir</button></li>
      </ul>
    </div>
  );
}

export default Sidebar;
